module.exports = __webpack_public_path__ + "img/blue_cross.f3c5ad63.svg";